export enum StoreContactTypeEnum {
  'whatsapp' = 'whatsapp',
  'email' = 'email',
  'phone_number' = 'phone_number',
}
